import type { PlayerKeyBindings, SettingsAction } from '../../infrastructure/settings/settings-schema';

export const GAME_TITLE = 'OFFICE CLASH - 定時なき戦い -';
export const GAME_TITLE_MAIN = 'OFFICE CLASH';
export const GAME_TITLE_SUB = '- 定時なき戦い -';
export const GAME_TAGLINE = '営業部 vs 開発部 — 深夜のオフィス頂上決戦';

export const formatKeyCode = (code: string): string => {
  if (code.startsWith('Key')) return code.slice(3);
  if (code.startsWith('Numpad')) {
    const num = code.slice(6);
    return `Num${num}`;
  }
  if (code.startsWith('Digit')) return code.slice(5);
  if (code === 'ArrowLeft') return '←';
  if (code === 'ArrowRight') return '→';
  if (code === 'ArrowUp') return '↑';
  if (code === 'ArrowDown') return '↓';
  if (code === 'BracketLeft') return '[';
  if (code === 'BracketRight') return ']';
  if (code === 'Space') return 'Space';
  if (code === 'Escape') return 'Esc';
  if (code === 'Enter') return 'Enter';
  return code;
};

export const formatKeyList = (keys: readonly string[]): string =>
  keys.map(formatKeyCode).join(' / ');

export const formatMovementKeys = (leftKeys: readonly string[], rightKeys: readonly string[]): string =>
  `${formatKeyList(leftKeys)} / ${formatKeyList(rightKeys)}`;

export const getHowToPlayControlRows = (bindings: PlayerKeyBindings): readonly string[] => [
  `左右移動 : ${formatMovementKeys(bindings.MOVE_LEFT, bindings.MOVE_RIGHT)}`,
  `しゃがむ : ${formatKeyList(bindings.CROUCH)}`,
  `ジャンプ : ${formatKeyList(bindings.JUMP)}`,
  `弱攻撃   : ${formatKeyList(bindings.LIGHT_ATTACK)}`,
  `強攻撃   : ${formatKeyList(bindings.HEAVY_ATTACK)}`,
  `スキル1  : ${formatKeyList(bindings.SKILL_1)}`,
  `スキル2  : ${formatKeyList(bindings.SKILL_2)}`,
  `ガード   : ${formatKeyList(bindings.GUARD)}`,
  `必殺技   : ${formatKeyList(bindings.SUPER)}`,
];

export const ACTION_LABELS: Readonly<Record<SettingsAction, string>> = Object.freeze({
  MOVE_LEFT: '左移動',
  MOVE_RIGHT: '右移動',
  JUMP: 'ジャンプ',
  CROUCH: 'しゃがむ',
  LIGHT_ATTACK: '弱攻撃',
  HEAVY_ATTACK: '強攻撃',
  SKILL_1: 'スキル1',
  SKILL_2: 'スキル2',
  GUARD: 'ガード',
  SUPER: '必殺技',
});

export const CHARACTER_SKILL_LABELS = Object.freeze({
  sales: Object.freeze({
    displayName: 'Sales（営業部）',
    skill1: '二枚舌ラッシュ',
    skill2: '無理な納期設定',
    super: 'できます！',
  }),
  developer: Object.freeze({
    displayName: 'Developer（開発部）',
    skill1: '仕様変更カウンター',
    skill2: 'スパゲッティコード',
    super: '深夜3時の強制ロールバック',
  }),
});

export const resolveSuperSkillName = (cinematicId: string, characterId?: 'sales' | 'developer'): string => {
  if (cinematicId.includes('sales')) return CHARACTER_SKILL_LABELS.sales.super;
  if (cinematicId.includes('developer')) return CHARACTER_SKILL_LABELS.developer.super;
  if (characterId && CHARACTER_SKILL_LABELS[characterId]) {
    return CHARACTER_SKILL_LABELS[characterId].super;
  }
  return '必殺技';
};

